/**
 * @typedef {Object} DataRequest
 * @property {string} type
 * @property {string} filters
 */

function DataRequester (studyName, completePath) {
    this.studyName = studyName
    this.completePath = completePath
    this.requests = []
    this.currentId = 0;
}

// DataRequester.prototype.addRankingTableRequest = function (callWithResult) {
//     this.requests.push( { requestId: this.currentId++, type: 'RankingTableRequest', expression: '', callback: callWithResult } )
// },

DataRequester.prototype.addPagedRankingTableRequest = function (externalName, currentPage, perPage, filter, sortBy, sortDesc) {
    this.requests.push( { requestId: this.currentId++, type: 'RankingTableRequest', extname: externalName, expression: '', currentPage: currentPage, perPage: perPage, filter: filter, sortBy: sortBy, sortDesc: sortDesc } )
}

DataRequester.prototype.addExpressionRequest = function (callWithResult, externalName, expr) {
    this.requests.push( { requestId: this.currentId++, type: 'ExpressionRequest', extname: externalName, expression: expr, callback: callWithResult } )
}

DataRequester.prototype.addChartRequest = function (callWithResult, externalName) {
    this.requests.push( { requestId: this.currentId++, type: 'ChartRequest', extname: externalName, callback: callWithResult } )
}

DataRequester.prototype.addDriversTableRequest = function (callWithResult, externalName) {
    this.requests.push( { requestId: this.currentId++, type: 'DriversTableRequest', extname: externalName, callback: callWithResult } )
}

DataRequester.prototype.addActionPlanRequest = function (callWithResult, externalName) {
    this.requests.push( { requestId: this.currentId++, type: 'ActionPlanRequest', extname: externalName, callback: callWithResult } )
}


DataRequester.prototype.hasRequests = function () {
    return this.requests.length>0
}

DataRequester.prototype.clearRequests = function () {
    return this.requests=[]
}

DataRequester.prototype.getRequests = function () {
    return this.requests
}

DataRequester.prototype.getRequests = function () {
    return this.requests
}


export default DataRequester
